export default {
    header: 'บันทึก NVR',
    searchText: 'ค้นหาชื่อ / รหัสพนักงาน',
    search: 'ค้นหา',
    type: 'ประเภท',
    employeeId: 'รหัสพนักงาน',
    name: 'ชื่อ-นามสกุล',
    imageSearch: 'ค้นหาพนักงานโดยรูป',
    date: 'วันที่',
    time: 'เวลา',
    image: 'รูปภาพ',
    location: 'สถานที่',
    temperature: 'อุณหภูมิ',
    exportPDF: 'ดาวน์โหลด PDF',
    exportExcel: 'ดาวน์โหลด Excel',
    somethingWrong: 'เกิดข้อผิดพลาด'
}
